import React from "react";
import Title from "antd/es/typography/Title";
import { Popover } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

interface PageTitleProps {
  children: React.ReactNode;
  infoTooltip?: string | React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  tooltipTrigger?: "click" | "hover";
  tooltipOverlayStyle?: React.CSSProperties;
}

const PageTitle: React.FC<PageTitleProps> = ({
  children,
  infoTooltip,
  className = "",
  style,
  tooltipTrigger = "click",
  tooltipOverlayStyle = { width: 400 },
}) => {
  return (
    <Title
      level={2}
      className={`font-bold flex items-center gap-1 ${className}`}
      style={style}
    >
      {children}
      {infoTooltip && (
        <Popover
          content={infoTooltip}
          trigger={tooltipTrigger}
          overlayStyle={tooltipOverlayStyle}

        >
          <InfoCircleOutlined className="h-5 w-5 cursor-pointer" />
        </Popover>
      )}
    </Title>
  );
};

export default PageTitle;

